import { forwardRef, useImperativeHandle, useState } from "react";
import { Image } from "antd";

export type ImagePreviewerRef = {
  openFilePreview: (input: string | string[]) => void;
};

export const ImagePreviewer = forwardRef<ImagePreviewerRef, {}>((_, ref) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewUrls, setPreviewUrls] = useState<string[]>([]);
  const [current, setCurrent] = useState(0);

  // 自定义暴露给父组件的 ref 接口
  useImperativeHandle(ref, () => ({
    openFilePreview: (input) => {
      let urls: string[] = [];
      let currentIndex = 0;

      if (Array.isArray(input)) {
        urls = [...input];
      } else if (typeof input === "string") {
        urls = [input];
      }

      if (urls.length === 0) return;

      // 默认打开第一张
      currentIndex = 0;

      setPreviewUrls(urls);
      setCurrent(currentIndex);
      setPreviewVisible(true);
    },
  }));

  return (
    <div style={{ display: "none" }}>
      <Image.PreviewGroup
        preview={{
          zIndex: 9999,
          visible: previewVisible,
          onVisibleChange: (vis) => {
            setPreviewVisible(vis);
            if (!vis) {
              // 关闭时重置（可选）
              setPreviewUrls([]);
              setCurrent(0);
            }
          },
          current,
          onChange: (currentIdx) => {
            setCurrent(currentIdx);
          },
        }}
      >
        {previewUrls.map((url, index) => (
          <Image key={index} src={url} alt="" />
        ))}
      </Image.PreviewGroup>
    </div>
  );
});
